export default __webpack_public_path__ + "static/media/powerPoint.6fedc0ad.svg";